import { DefaultOptionType } from "../../defaultOptionType";
import { Capability } from "../formElementCapability";
import { FormElementType } from "~/enums/formElementType";
import IFormElementSchema from "./iFormElementSchema";
import { MMCCProviderItems, MMCCProviderItemsWithOther, MMCCYesNoItems } from "./mmccProviderDropdownSchema";
import { baseDropdownItemRestrictions, generateDropdownItemRestrictions } from "./schemaHelper";

export const baseRestrictions: Capability[] = [
  // Capability.defaultable,
  Capability.maskable,
  Capability.repeatable,
  Capability.lengthable,
  // Capability.readonlyable,
  // Capability.showHideable,
  Capability.formatable,
  Capability.sortable,
  Capability.destroyable,
  Capability.layoutable,
  Capability.verticalAlign,
  Capability.profileConfig,
  Capability.indexable,
  // Capability.requireable,
];

export const restrictionSchema: object = {
  self: baseRestrictions,
  children: [
    {
      // Grid
      self: [...baseRestrictions],
      children: [
        {
          // SSN
          self: baseRestrictions,
        },
        {
          // DOB
          self: [...baseRestrictions],
        },
      ]
    },
    {
      // Provider Selection
      self: [...baseRestrictions, Capability.defaultOption],
      children: generateDropdownItemRestrictions(MMCCProviderItems.length, baseDropdownItemRestrictions)
    },
    {
      // Provider Selection with Pharmancy & Other
      self: [...baseRestrictions, Capability.defaultOption],
      children: generateDropdownItemRestrictions(MMCCProviderItemsWithOther.length, baseDropdownItemRestrictions)
    },
    {
      // License Board manual input
      self: baseRestrictions
    },
    {
      // Board License Number
      self: baseRestrictions
    },
    {
      // Expiration Date
      self: baseRestrictions
    },
    {
      // Paragraph Board of Nursing License
      self: baseRestrictions
    },
    {
      // Paragraph Board of Physicians
      self: baseRestrictions
    },
    {
      // Paragraph Board of Dental Examiners
      self: baseRestrictions
    },
    {
      // CDS License Number
      self: baseRestrictions
    },
    {
      // Paragraph CDS System
      self: baseRestrictions
    },
    {
      // Divider
      self: baseRestrictions
    },
    {
      // Physician Assistant Yes/No select
      self: [...baseRestrictions, Capability.defaultOption],
      children: generateDropdownItemRestrictions(MMCCYesNoItems.length, baseDropdownItemRestrictions)
    },
    {
      // MBP License Number of Supervising Physician
      self: baseRestrictions
    },
    {
      // Prescriptive Authority Yes/No select
      self: [...baseRestrictions, Capability.defaultOption],
      children: generateDropdownItemRestrictions(MMCCYesNoItems.length, baseDropdownItemRestrictions)
    },
  ]
};


export const formElementsSchema: Array<IFormElementSchema> = [
  {
    formElementType: FormElementType.grid,
    json: {
      sort_order: 0,
      layout_config: [1, 1],
    },
    formElements: [
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: 'SSN',
          sort_order: 0,
          format_type: 12,
          is_masked: true,
        },
      },
      {
        formElementType: FormElementType.textField,
        json: {
          label_title: 'DOB',
          sort_order: 1,
        },
      },
    ]
  },
  {
    formElementType: FormElementType.dropdown,
    json: {
      label_title: "I am licensed by",
      sort_order: 1,
      default_option_locked: true,
      default_option_type: DefaultOptionType.None
    },
    formElements: MMCCProviderItems
  },
  {
    formElementType: FormElementType.dropdown,
    json: {
      label_title: "I am licensed by",
      sort_order: 2,
      default_option_locked: true,
      default_option_type: DefaultOptionType.None
    },
    formElements: MMCCProviderItemsWithOther
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'What Medical Board are you licensed with?',
      sort_order: 3,
    },
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Medical License Number',
      sort_order: 4,
    },
  },
  {
    formElementType: FormElementType.dateTimePicker,
    json: {
      label_title: 'Expiration Date',
      sort_order: 5,
    },
  },
  {
    formElementType: FormElementType.paragraph,
    json: {
      label_title: '<a href="http://mbon.maryland.gov/Pages/lic-lookup.aspx" target="_blank">Click here to access Board of Nursing License Verification site.</a>',
      sort_order: 6,
    }
  },
  {
    formElementType: FormElementType.paragraph,
    json: {
      label_title: 'Please enter license# as X99999 - drop 2 leading zeros. This is same as License Number you enter to create/edit profile in Maryland Board of Physicians Practitioner Profile System<br><br><a href="https://www.mbp.state.md.us/bpqapp/" target="_blank">Click here to access the Maryland Board of Physicians Practitioner Profile System.</a>',
      sort_order: 7,
    }
  },
  {
    formElementType: FormElementType.paragraph,
    json: {
      label_title: '<a href="https://maryland.mylicense.com/mdbodverif/Search.aspx" target="_blank">Click here to access Board of Dental Examiners License Verification site.</a>',
      sort_order: 8,
    }
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'Controlled Dangerous Substances (CDS) Registration Number',
      sort_order: 9,
    }
  },
  {
    formElementType: FormElementType.paragraph,
    json: {
      label_title: '<a href="https://health.maryland.gov/OCSA/Pages/home.ASPX" rel="noopener noreferrer" target="_blank">Click here to access Controlled Dangerous Substances (CDS) System.</a>',
      sort_order: 10,
    }
  },
  {
    formElementType: FormElementType.divider,
    json: {
      sort_order: 11,
    }
  },
  {
    formElementType: FormElementType.radioButtonGroup,
    json: {
      label_title: "Are you a Physician Assistant",
      sort_order: 12,
      default_option_locked: true,
      default_option_type: DefaultOptionType.None
    },
    formElements: MMCCYesNoItems
  },
  {
    formElementType: FormElementType.textField,
    json: {
      label_title: 'MBP License Number of Supervising Physician',
      sort_order: 13,
    }
  },
  {
    formElementType: FormElementType.radioButtonGroup,
    json: {
      label_title: "Do you have prescriptive Authority?",
      sort_order: 14,
      default_option_locked: true,
      default_option_type: DefaultOptionType.None
    },
    formElements: MMCCYesNoItems
  },
];